const ALERT_TYPES = {
  notFound: 1,
  answer: 2,
  wait: 3,
};

export const ALERTS = {
  [ALERT_TYPES.notFound]: {
    text: 'К сожалению нейросеть не нашла подходящего ответа в базе знаний на заданный вопрос. '
      + 'Вы можете пополнить базу знаний ответом на него '
      + '(и сразу отправить этот ответ обучающемуся), '
      + 'либо просто ответить на вопрос, не добавляя его в базу знаний.',
    attrs: {
      color: 'error',
      class: 'white--text text--lighten-1',
      icon: 'mdi-robot-dead',
    },
    actions: [
      {
        attrs: {
          is: 'v-switch',
          label: 'Пополнить базу знаний',
          class: 'mt-2',
          color: 'success',
          inset: true,
          'hide-details': true,
        },
        listeners: {
          change: (val) => ({ key: 'saveAnswer', value: val }),
        },
      },
    ],
  },
  [ALERT_TYPES.answer]: {
    text: 'Нейросеть подготовила возможный ответ на вопрос.',
    attrs: {
      class: 'success--text text--lighten-1',
      color: 'success',
      icon: 'mdi-robot',
    },
    actions: [
      {
        text: 'Неверный ответ?',
        attrs: {
          is: 'span',
          class: 'text--success mt-2',
        },
        listeners: {
          change: (val) => ({ key: 'saveAnswer', value: val }),
        },
      },
      {
        attrs: {
          is: 'v-switch',
          label: 'Пополнить базу знаний',
          class: 'mt-2 mr-2',
          color: 'success',
          inset: true,
          'hide-details': true,
        },
        listeners: {
          change: (val) => ({ key: 'saveAnswer', value: val }),
        },
      },
      {
        attrs: {
          is: 'v-btn',
          class: 'ml-auto mt-2',
          depressed: true,
          color: 'success',
        },
        text: 'Скопировать',
        listeners: {
          click: (val) => ({ key: 'copyTextAnswer', value: val }),
        },
      },
    ],
  },
  [ALERT_TYPES.wait]: {
    text: 'Нейросеть подготавливает возможный ответ на вопрос.',
    attrs: {
      class: 'info--text text--lighten-1',
      color: 'info',
      icon: 'mdi-robot-happy',
    },
  },
};

export default {
  ALERTS,
};
